import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ScrollToTop } from "../ui/ScrollToTop";
import Footer from "./Footer";

import Header from "./header/Header";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-n-bg-1">
      <Header />
      <main className="flex-1 mt-[56px] md:mt-[72px]">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
